export function hexToRgb(color?: string) {
    if (!color?.length) return '';
    if (!color?.includes('#')) return color;
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    if (!result?.[1] || !result?.[2] || !result?.[3]) return null;
    return [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)].join(',');
}
